/***
 **Module Name: BlockBuyer
 **File Name :  BlockBuyer.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains BlockBuyer details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../SessionPopup"
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import axios from 'axios';
let { lambda, country, appname } = window.app;

const FrontendSettings = () => {

    const navigate = useNavigate();
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
 const [duration, setDuration] = useState(null);
 const [success, setSuccess] = useState(false);
 const [isLoading, setIsLoading] = useState(false);
  const [image, setImg] = useState("");
    const { userData, setSelectedOptions,setActiveMenuObj, setMultiSelectFields, setActiveFieldsObj, setSelectedOptionsClientName, setSearchPayload, route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, setActiveMenuId ,GetTimeActivity} = useContext(contentContext);


    useEffect(() => {
        setRoute("frontend")
        setActiveMenuId(200007)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
        userActivity();
        setSelectedOptions([])
        setMultiSelectFields({ dubbinglanguages: [], typeofrights: [], countryorigin: [], languages: [], typeofrights: [], genre: [], videoquality: [], certificate: [], subtitleslanguages: [], territoriesavailable: [], sport: [], musicgenre: [] })
        setActiveFieldsObj({ CookingshowActive: false, seriesActive: false, SportsActive: false, LiveEventActive: false, MusicActive: false })
        setSelectedOptionsClientName([])
        setSearchPayload({})
    }, []);

    
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


   const previousId = localStorage.getItem("previousid");
const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }else
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }


    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute != undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [route]);
    useEffect(() => {
    
            if (window.site === undefined) {
                setTimeout(() => {
                     if (window.site && window.site.common && window.site.common.imagesCDN) {
                setImg(window.site.common.imagesCDN)
            }
                    if (window.site && window.site.duration ) {
                        setDuration(window.site.duration)
                    }
                }, 1000);
            }
              if (window.site && window.site.common && window.site.common.imagesCDN) {
                setImg(window.site.common.imagesCDN)
            }
            if (window.site && window.site.common && window.site.common.imagesCDN) {
                setDuration(window.site.duration)
            }
    
        }, [window.site]);

    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Frontend Settings")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
   
    const handleClickMenu = (e, item) => {
        GetTimeActivity()   
        console.log("item", item)

        let id = item.menuname.split(" ").join("").toLowerCase()
        console.log("id", id)
        if (item.edit == true) {
            navigate("/" + id);
        }
    }
    const handleViewClickMenu = (e, item) => {
        GetTimeActivity()   
        let id = item.menuname.split(" ").join("").toLowerCase()
        console.log("id", id)
        if (id === "terms") {
            navigate("/" + "view" + id);
        }
        if (id === "privacypolicy") {
            navigate("/" + "view" + id);
        }
        if (id === "team") {
            navigate("/" + "view" + id);
        }
        if (id === "aboutus") {
            navigate("/" + "view" + id);
        }
        if (id === "advancedsearch") {
            navigate("/" + "view" + id);
        }
        if (id === "landingpage") {
            navigate("/" + "view" + id);
        }
    }
    const handleView=()=>{
navigate("/viewwelcomemessage")
    }
    const handleManage=()=>{
        navigate("/welcomemessage")
    }
    const handleLandingPage = () => {
        navigate("/landingpage")
    }
    const handleAdvanceSearch = () => {
        navigate("/advancedsearch")
    }

    const handlePrivacy = () => {
        navigate("/privacy")
    }
    const handleTerms = () => {
        navigate("/terms")
    }
    const handleChange = (e) => {
    setDuration(e.target.value); // updates duration on typing
  };
//   const handleUpdate=async()=>{
//     setIsLoading(true)
//      try {
//     const payload = {
//     duration:duration
//     };

//     const previousId = localStorage.getItem("previousid");
//     const urlLink =
//       lambda +
//       "/config?appname=" +
//       appname +
//       (previousId ? "&previousid=" + previousId : "");

//     const response = await axios.post(urlLink, payload);

//     if (response?.data?.result === "Invalid token or Expired") {
//       setShowSessionPopupup(true);
//       setIsLoading(false)
//     } else if (response?.data?.result === "Updated Successfully") {
     
//       setSuccess(true)
//       if (typeof window.websiteDefaults === "function") {
//   window.websiteDefaults();
// }
// setIsLoading(false)
//     }
//   } catch (error) {
//     console.error("Error while sending user activity:", error);
//     setIsLoading(false)
//   }
//   }
    return (
        <>
         {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <div className="main-content create-user edit-content add-client">

                    <div className="page-content ">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <h4 className="mb-2 card-title">FRONTEND SETTINGS</h4>
                                      

                                    </div>
                                </div>
                            </div>
                            <div className="create-user-block">

                                <div className="form-block">

                                    <div className="frontend_settings">
                                        {subValDashboard && Object.keys(subValDashboard).map((eachItem) => {
                                            let eachValue = subValDashboard[eachItem]
                                            console.log('eachiivalues', eachValue)
                                            return (
                                                <div className="page_item" key={eachValue.submenuid}>
                                                    <h2>{eachValue.menuname}</h2>
                                                    <div className="d-flex">
                                                        <a onClick={(e) => handleViewClickMenu(e, eachValue)} className="text-danger action-button"><i className="mdi mdi-eye font-size-18"></i>View</a>
                                                        {eachValue && eachValue.display === true &&
                                                            <a onClick={(e) => handleClickMenu(e, eachValue)} className={`${eachValue && eachValue.enable === false ? 'pe-none' : ''} text-danger action-button`}><i className="mdi mdi-cog-outline font-size-18"></i>Manage</a>}
                                                    </div>
                                                    
                                                </div>
                                                
                                            )
                                        })}
                                      <div className="page_item">
                                            <h2>WELCOME MESSAGE </h2>
                                            {/* <div className="d-flex dura-btn-input align-items-center">
                                                <p style={{marginBottom:"0",marginRight:"10px"}}>Eg: 200k+</p>
                                                <input className="frontend-duration ps-2 pe-1" style={{height:"31.6px"}} type="enter" value={duration} onChange={handleChange} name="" id="" />
                                                <a className={`duration-update-btn ${duration === "0" || duration === "" ? "disable pe-none" : ""}`} onClick={handleUpdate} >{isLoading ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}Update</a>
                                            </div> */}
                                            <div className="d-flex">
                                                        <a  className="text-danger action-button" onClick={handleView}><i className="mdi mdi-eye font-size-18"></i>View</a>
                                                       
                                                            <a  className={`text-danger action-button`}  onClick={handleManage}><i className="mdi mdi-cog-outline font-size-18"></i>Manage</a>
                                                    </div>
                                        </div>
                                       
                                    </div>

                                </div>

                            </div>


                        </div>
                    </div>

  <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Duration updated successfully"}
                        onConfirm={e => setSuccess(false)}
                    >
                    </SweetAlert>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default FrontendSettings;